import axios from "axios";
import { API } from "../context/AuthContext";

const b64ToU8 = (v) => {
  const pad = "=".repeat((4 - (v.length % 4)) % 4);
  const raw = atob((v + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && window.isSecureContext;

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Questo browser non supporta le notifiche push");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/public-key`);
  let sub = await reg.pushManager.getSubscription();
  sub = sub || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.publicKey) }));
  await axios.post(`${API}/push/subscribe`, sub.toJSON());
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await currentSubscription();
  if (!sub) return;
  await axios.delete(`${API}/push/subscribe`, { params: { endpoint: sub.endpoint } }).catch(() => {});
  await sub.unsubscribe();
}
